module.exports = __webpack_public_path__ + "static/media/info-icon-grey.88453bfe.svg";